var map = {
	"./music-instructions.json": 4643,
	"./music-library-intro2024.json": 4644,
	"./music-library-launch2024.json": 4645,
	"./music-progression.json": 4646,
	"./startSourcesAdvanced.json": 4647,
	"./startSourcesSimple.json": 4648,
	"./startSourcesSimple2.json": 4649,
	"./startSourcesTracks.json": 4650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4421;